// extracted by mini-css-extract-plugin
export default {"holder_new_request":"dealerRequestKits_holder_new_request__IOskt","customtab":"dealerRequestKits_customtab__Hr4fv"};